import GenericDB from './generic-db';

export default class AssessmentDataDB extends GenericDB {
  constructor() {
    super('assessmentData');
  }
}
